import { getAudio } from "@/audio";

export const acidPulse = { v: 0, last: 0 };
const SCALE = [0, 3, 5, 7, 10, 12, 15];
const CURVE = Float32Array.from({ length: 256 }, (_, i) => Math.tanh(((i / 128) - 1) * 2.5));
const pick = (a) => a[Math.floor(Math.random() * a.length)];

export const playAcidRiff = () => {
  const { ctx, out } = getAudio();
  const bpm = 124 + Math.random() * 16;
  const step = 60 / bpm / 4;
  const root = pick([36, 38, 41, 43]);
  const steps = pick([8, 16, 16]);
  const o = ctx.createOscillator();
  o.type = Math.random() < 0.75 ? "sawtooth" : "square";
  const f = ctx.createBiquadFilter();
  f.type = "lowpass";
  f.Q.value = 14 + Math.random() * 10;
  const g = ctx.createGain();
  g.gain.value = 0;
  const dist = ctx.createWaveShaper();
  dist.curve = CURVE;
  o.connect(f).connect(dist).connect(g).connect(out);
  const t0 = ctx.currentTime + 0.05;
  const sweep = Math.random() * 1500;
  for (let i = 0; i < steps; i++) {
    const t = t0 + i * step;
    if (Math.random() < 0.18) continue;
    const note = root + pick(SCALE) + (Math.random() < 0.2 ? 12 : 0);
    const hz = 440 * 2 ** ((note - 69) / 12);
    if (Math.random() < 0.3) o.frequency.linearRampToValueAtTime(hz, t + step * 0.6);
    else o.frequency.setValueAtTime(hz, t);
    const accent = Math.random() < 0.3;
    const peak = 300 + sweep * (i / steps) + (accent ? 2200 : 900);
    f.frequency.setValueAtTime(peak, t);
    f.frequency.exponentialRampToValueAtTime(180, t + step * 0.9);
    g.gain.setValueAtTime(accent ? 0.16 : 0.1, t);
    g.gain.setTargetAtTime(0.0001, t + step * 0.7, 0.02);
    setTimeout(() => { const nowMs = performance.now(); if (nowMs - acidPulse.last < 400) return; acidPulse.v = accent ? 1 : 0.6; acidPulse.last = nowMs; }, (t - ctx.currentTime) * 1000);
  }
  const end = t0 + steps * step + 0.2;
  o.start(t0);
  o.stop(end);
  const stop = () => { try { o.stop(); } catch { /* already stopped */ } g.disconnect(); };
  setTimeout(() => g.disconnect(), (end - ctx.currentTime) * 1000 + 200);
  window.__acidRiffs = (window.__acidRiffs || 0) + 1;
  return { len: steps * step, stop };
};
